module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_RO-8add6a63772efaaba410a2a1667dd6a5.svg";